import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PanoramaInteractions } from '../consts';
import { DeliveryOptionsService } from '../services/DeliveryOptionsService';
import { SPECS } from '../specs';
import { ComponentState, DisplayState } from '../types';
import { deliveryOptionsMapper } from '../utils/deliveryOptionsMappers';
import { loadTranslations, initializeI18n } from '../utils/i18n';
import { getLocale } from '../utils/deliveryOptionsUtils';
export class DeliverySectionController {
  constructor(controllerParams) {
    _defineProperty(this, "locale", void 0);
    _defineProperty(this, "translationLang", void 0);
    _defineProperty(this, "flowAPI", void 0);
    _defineProperty(this, "onStateChanged", void 0);
    _defineProperty(this, "controllerConfig", void 0);
    _defineProperty(this, "setDeliveryMethodId", void 0);
    _defineProperty(this, "getDeliverySectionParams", void 0);
    _defineProperty(this, "biLogger", void 0);
    _defineProperty(this, "deliveryOptionsService", void 0);
    _defineProperty(this, "displayState", void 0);
    _defineProperty(this, "_deliverySectionData", void 0);
    _defineProperty(this, "tFunction", void 0);
    _defineProperty(this, "setDisplayState", async displayState => {
      this.setDeliverySectionData({
        isControllerReady: false
      });
      this.displayState = displayState;
      await this.onDataChanged();
      this.setDeliverySectionData({
        isControllerReady: true,
        displayState: this.displayState
      });
    });
    _defineProperty(this, "setShouldShowOnlyPickup", shouldShowOnlyPickup => {
      this.setDeliverySectionData({
        shouldShowOnlyPickup
      });
    });
    _defineProperty(this, "setDeliveryMethodIdHandler", async (deliveryMethodId, groupId) => {
      var _this$_deliverySectio, _this$biLogger, _this$flowAPI$panoram, _this$flowAPI$panoram2;
      if (deliveryMethodId === ((_this$_deliverySectio = this._deliverySectionData.selectedDeliveryOption) == null ? void 0 : _this$_deliverySectio.id)) {
        return;
      }
      (_this$biLogger = this.biLogger) == null || _this$biLogger.onDeliveryMethodSelected == null || _this$biLogger.onDeliveryMethodSelected({
        deliveryOptions: [...this._deliverySectionData.deliveries.deliveryMethods, ...this._deliverySectionData.deliveries.pickupMethods],
        selectedDeliveryOption: deliveryMethodId,
        hasPartialShippingOptions: this._deliverySectionData.hasPartialShippingOptions
      });
      this.setDeliverySectionData({
        selectedDeliveryOption: {
          id: deliveryMethodId,
          groupId
        }
      });
      (_this$flowAPI$panoram = this.flowAPI.panoramaClient) == null || (_this$flowAPI$panoram = _this$flowAPI$panoram.transaction(PanoramaInteractions.DeliverySectionUpdateSelectedDeliveryOption)) == null || _this$flowAPI$panoram.start == null || _this$flowAPI$panoram.start();
      await this.setIsLoading();
      await this.setDeliveryMethodId(deliveryMethodId);
      await this.setIsReady();
      (_this$flowAPI$panoram2 = this.flowAPI.panoramaClient) == null || (_this$flowAPI$panoram2 = _this$flowAPI$panoram2.transaction(PanoramaInteractions.DeliverySectionUpdateSelectedDeliveryOption)) == null || _this$flowAPI$panoram2.finish == null || _this$flowAPI$panoram2.finish();
    });
    const {
      flowAPI,
      controllerConfig,
      biLogger,
      getDeliverySectionParams,
      onStateChanged,
      setDeliveryMethodId
    } = controllerParams;
    this.locale = getLocale(controllerConfig);
    this.translationLang = flowAPI.translations.config.language;
    this.flowAPI = flowAPI;
    this.controllerConfig = controllerConfig;
    this.biLogger = biLogger;
    this.getDeliverySectionParams = getDeliverySectionParams;
    this.onStateChanged = onStateChanged;
    this.setDeliveryMethodId = setDeliveryMethodId;
    const experiments = Object.values(SPECS).reduce((acc, spec) => {
      acc[spec] = controllerParams.controllerConfig.essentials.experiments.enabled(spec);
      return acc;
    }, {});
    this.deliveryOptionsService = new DeliveryOptionsService({
      locale: this.locale,
      translationLang: this.translationLang,
      httpClient: flowAPI.httpClient,
      errorHandler: flowAPI.errorHandler,
      timezone: controllerParams.controllerConfig.wixCodeApi.site.timezone,
      experiments: controllerParams.controllerConfig.essentials.experiments
    });
    this.displayState = DisplayState.HIDDEN;
    this._deliverySectionData = {
      deliveries: {
        pickupMethods: [],
        deliveryMethods: []
      },
      displayState: this.displayState,
      setDisplayState: this.setDisplayState,
      setDeliveryMethodId: this.setDeliveryMethodIdHandler,
      setShouldShowOnlyPickup: this.setShouldShowOnlyPickup,
      canShipToDestination: false,
      hasShippingOptions: false,
      isUpdatingShippingOption: false,
      locale: this.locale,
      translationLang: this.translationLang,
      hasPartialShippingOptions: false,
      experiments,
      isControllerReady: false
    };
  }
  async setDeliverySectionData(deliverySectionData) {
    this._deliverySectionData = {
      ...this._deliverySectionData,
      ...deliverySectionData
    };
    this.controllerConfig.setProps({
      _deliverySectionData: this._deliverySectionData
    });
  }
  async setIsLoading() {
    this.setDeliverySectionData({
      isUpdatingShippingOption: true
    });
    this.onStateChanged(ComponentState.LOADING);
  }
  async setIsReady() {
    var _this$_deliverySectio2;
    this.setDeliverySectionData({
      isUpdatingShippingOption: false
    });
    const isEditable = this.displayState === DisplayState.EDITABLE;
    const isEditableValid = this._deliverySectionData.canShipToDestination && ((_this$_deliverySectio2 = this._deliverySectionData.selectedDeliveryOption) == null ? void 0 : _this$_deliverySectio2.groupId);
    const isValid = !isEditable || isEditableValid;
    this.onStateChanged(isValid ? ComponentState.READY : ComponentState.INVALID);
  }
  async setDefaultSelectedDeliveryOption(deliverySectionParams) {
    if (deliverySectionParams != null && deliverySectionParams.defaultSelectedDeliveryOption) {
      var _deliverySectionParam;
      const shouldUseClientFormattingForPrices = this.controllerConfig.essentials.experiments.enabled(SPECS.ClientFormattingForPrices);
      const {
        groupedDeliveryOptions,
        selectedDeliveryOption
      } = deliveryOptionsMapper([deliverySectionParams == null ? void 0 : deliverySectionParams.defaultSelectedDeliveryOption], {
        timezone: this.controllerConfig.wixCodeApi.site.timezone,
        selectedDeliveryCode: deliverySectionParams == null || (_deliverySectionParam = deliverySectionParams.userPreferences) == null || (_deliverySectionParam = _deliverySectionParam[0]) == null ? void 0 : _deliverySectionParam.code,
        t: this.tFunction,
        language: this.locale,
        currency: deliverySectionParams == null ? void 0 : deliverySectionParams.currency
      }, shouldUseClientFormattingForPrices);
      const defaultSelectedDeliveryOptionData = Object.values(groupedDeliveryOptions)[0];
      this.setDeliverySectionData({
        selectedDeliveryOption,
        defaultSelectedDeliveryOptionData
      });
    }
  }
  async loadDeliverySectionData(deliverySectionParams) {
    var _this$flowAPI$panoram3, _deliverySectionParam2, _this$flowAPI$panoram4, _this$biLogger2;
    (_this$flowAPI$panoram3 = this.flowAPI.panoramaClient) == null || (_this$flowAPI$panoram3 = _this$flowAPI$panoram3.transaction(PanoramaInteractions.DeliverySectionLoadDeliveryOptions)) == null || _this$flowAPI$panoram3.start == null || _this$flowAPI$panoram3.start();
    const {
      errors,
      deliveries,
      canShipToDestination,
      selectedDeliveryOption,
      hasPartialShippingOptions
    } = await this.deliveryOptionsService.getDeliveryOptions(deliverySectionParams, deliverySectionParams == null || (_deliverySectionParam2 = deliverySectionParams.userPreferences) == null || (_deliverySectionParam2 = _deliverySectionParam2[0]) == null ? void 0 : _deliverySectionParam2.code, this._deliverySectionData.shouldShowOnlyPickup);
    (_this$flowAPI$panoram4 = this.flowAPI.panoramaClient) == null || (_this$flowAPI$panoram4 = _this$flowAPI$panoram4.transaction(PanoramaInteractions.DeliverySectionLoadDeliveryOptions)) == null || _this$flowAPI$panoram4.finish == null || _this$flowAPI$panoram4.finish();
    (_this$biLogger2 = this.biLogger) == null || _this$biLogger2.onDataPresented == null || _this$biLogger2.onDataPresented({
      deliveryOptions: [...deliveries.deliveryMethods, ...deliveries.pickupMethods],
      hasPartialShippingOptions
    });
    this.setDeliverySectionData({
      deliveries,
      selectedDeliveryOption,
      hasPartialShippingOptions,
      canShipToDestination,
      deliveryErrors: errors,
      violations: deliverySectionParams == null ? void 0 : deliverySectionParams.violations,
      appliedCouponType: deliverySectionParams == null ? void 0 : deliverySectionParams.appliedCouponType
    });
  }
  async loadData() {
    if (this.displayState === DisplayState.HIDDEN) {
      return;
    }
    const deliverySectionParams = await this.getDeliverySectionParams();
    this.displayState === DisplayState.EDITABLE && (await this.loadDeliverySectionData(deliverySectionParams));
    this.displayState === DisplayState.READ_ONLY && (await this.setDefaultSelectedDeliveryOption(deliverySectionParams));
  }
  async init() {
    var _this$flowAPI$panoram5, _this$flowAPI$panoram6;
    (_this$flowAPI$panoram5 = this.flowAPI.panoramaClient) == null || (_this$flowAPI$panoram5 = _this$flowAPI$panoram5.transaction(PanoramaInteractions.DeliverySectionControllerInit)) == null || _this$flowAPI$panoram5.start == null || _this$flowAPI$panoram5.start();
    const translations = await loadTranslations(this.translationLang);
    this.tFunction = initializeI18n(translations, this.translationLang).t;
    this.deliveryOptionsService.init(this.tFunction);
    this.setDeliverySectionData({
      translations
    });
    (_this$flowAPI$panoram6 = this.flowAPI.panoramaClient) == null || (_this$flowAPI$panoram6 = _this$flowAPI$panoram6.transaction(PanoramaInteractions.DeliverySectionControllerInit)) == null || _this$flowAPI$panoram6.finish == null || _this$flowAPI$panoram6.finish();
  }
  async onDataChanged() {
    var _this$flowAPI$panoram7, _this$flowAPI$panoram8;
    (_this$flowAPI$panoram7 = this.flowAPI.panoramaClient) == null || (_this$flowAPI$panoram7 = _this$flowAPI$panoram7.transaction(PanoramaInteractions.DeliverySectionOnDataChanged)) == null || _this$flowAPI$panoram7.start == null || _this$flowAPI$panoram7.start();
    await this.setIsLoading();
    await this.loadData();
    await this.setIsReady();
    (_this$flowAPI$panoram8 = this.flowAPI.panoramaClient) == null || (_this$flowAPI$panoram8 = _this$flowAPI$panoram8.transaction(PanoramaInteractions.DeliverySectionOnDataChanged)) == null || _this$flowAPI$panoram8.finish == null || _this$flowAPI$panoram8.finish();
  }
}
//# sourceMappingURL=DeliverySectionController.js.map